var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResources3Icon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32.686,
  height: 32.686,
  viewBox: "0 0 32.686 32.686"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7654fd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.469 31.921a9.37 9.37 0 0 0-8.821-6.264h-.008a9.37 9.37 0 0 0-8.82 6.264",
  "data-name": "Path 258"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.692 14.911a9.545 9.545 0 0 0 10.644 2.138",
  "data-name": "Path 259"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.896 17.826a5.742 5.742 0 1 0 5.742-5.742 5.74 5.74 0 0 0-5.742 5.742",
  "data-name": "Path 260"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.47 21.481a4.176 4.176 0 1 0 4.176-4.176 4.176 4.176 0 0 0-4.176 4.176",
  "data-name": "Path 261"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.883 27.867a6.24 6.24 0 0 0-7.119 4.054",
  "data-name": "Path 262"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.643 25.657v6.264",
  "data-name": "Path 263"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.087 31.92V.599H14.338l4.176 4.176-4.176 4.177h17.749",
  "data-name": "Path 264"
}))));
export default SvgResources3Icon;